module.exports = __webpack_public_path__ + "img/export_arrow_icon.3acab89f.svg";